import { PRIMARY_DELETED_ITEMS_DISTINGUISHED_ID, ARCHIVE_DELETED_ITEMS_DISTINGUISHED_ID, } from 'owa-folders';
import { isFolderUnderDeletedItemsFolder } from 'owa-mail-store';
/**
 * Utility to check whether a folder is under the deleted items folder for any mailbox
 * @param folder
 */
export default function isUnderDeletedItemsFolderFromAnyMailbox(folder) {
    return (folder &&
        (isFolderUnderDeletedItemsFolder(folder, PRIMARY_DELETED_ITEMS_DISTINGUISHED_ID) ||
            isFolderUnderDeletedItemsFolder(folder, ARCHIVE_DELETED_ITEMS_DISTINGUISHED_ID)));
}
//# sourceMappingURL=isUnderDeletedItemsFolderFromAnyMailbox.js.map